import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import React, { useEffect, useMemo, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useLocation, useParams } from "react-router-dom"
import { useCookies } from "react-cookie"
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io"

export default function Shop() {
    const [pageLoading, setPageLoading] = useState(true);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount } = useCart();
    const [offset, setOffset] = useState(0);
    const [pagination, setPagination] = useState({total_product: 0})
    const [categoryFilter, setCatFilter] = useState([]);
    const [subCategoryFilter, setSubCatFilter] = useState([]);
    const {state} = useLocation();
    const [sortBy, setSortBy] = useState(state?.sort ?? '');
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [subCategories, setSubCat] = useState([]);
    const [searchParam, setSearchParam] = useState('');
    const {lnk_prod_id,lnk_prod_name} = useParams();
    const [cookies] = useCookies();

    useEffect(() => {
        getData();
        if (state?.product_id != undefined) {
            setShowDetails({ product_id: state?.product_id, name: state?.name });
            setShowModal(true);
        }
        if (lnk_prod_id != undefined && lnk_prod_id != "" && lnk_prod_id != null) {
            setShowDetails({ product_id: lnk_prod_id, name: lnk_prod_name });
            setShowModal(true);
        }
    }, [])
    

    function changePage() {
        setOffset(products?.length);
    }

    useEffect(() => {
        getData();
    }, [offset])

    useEffect(() => {
        resetData();
        setOffset(0);
    }, [sortBy, searchParam])

    async function resetData() {
        const formData = new FormData();
        formData.append('offset', 0);
        formData.append('sortBy', sortBy);
        formData.append('category_filter', JSON.stringify(categoryFilter));
        formData.append('sub_category_filter', JSON.stringify(subCategoryFilter));
        formData.append('searchParam', searchParam);
        try {
            const response = await axios.post(base_url + '/fetch_shop_products.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                setProducts(response.data.data);
                setPagination({ total_product: response.data.total_count })
            } else {

            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function getData() {
        const formData = new FormData();
        formData.append('offset', offset);
        formData.append('sortBy', sortBy);
        formData.append('category_filter', JSON.stringify(categoryFilter));
        formData.append('sub_category_filter', JSON.stringify(subCategoryFilter));
        formData.append('searchParam', searchParam);

        try {
            const response = await axios.post(base_url + '/fetch_shop_products.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                setProducts([...products, ...response.data.data]);
                setPagination({ total_product: response.data.total_count })
                setSubCat(response.data.sub_categories);
            } else {

            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
        }
    }

    const addFilter = (value, category) => {
        const array = categoryFilter;
        const index = array.findIndex(
            item => item === category
        );
        if (index != -1) {
            array.splice(index, 1);
            setCatFilter(array);
        } else {
            array.push(category);
            setCatFilter(array);
        }
        resetData();
    }

    const addSubFilter = (value, category) => {
        const array = subCategoryFilter;
        const index = array.findIndex(
            item => item === category
        );
        if (index != -1) {
            array.splice(index, 1);
            setSubCatFilter(array);
        } else {
            array.push(category);
            setSubCatFilter(array);
        }
        resetData();
    }

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            {showModal &&
            <ProductDetails 
                setShowModal={setShowModal}
                showModal={showModal}
                showDetails={showDetails}
            />
            }
            <Navbar />
            <div className="bg-gradient-to-r from-slate-900 to-slate-800 text-white px-6 py-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-lg font-semibold">Inside Gist</h2>
                    <p className="text-sm mt-1">
                    Get up to 80% discount on all products with our slash sales this year. Sign-up and start shopping now to earn higher discounts
                    <span className="font-semibold ml-2 cursor-pointer">Read More</span>
                    </p>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-4 py-6">
                <div className="flex flex-col md:flex-row gap-6">
                    <aside className="relative md:sticky md:top-10 h-[min-content] block w-full md:w-64 bg-white p-4 border rounded">
                        {/* <FilterGroup title="Prices">
                            <p className="text-sm">$120 - $300</p>
                            <input type="range" className="w-full mt-2" />
                        </FilterGroup> */}

                        <FilterGroup title="Categories">
                            {cookies?.categories?.map(b => (
                            <label key={b.id} className="flex items-center gap-2 mb-1 md:mb-0 text-sm mr-2 md:mr-0">
                                <input onChange={(e) => addFilter(e.target.checked, b.id)} type="checkbox" /> {b.name}
                            </label>
                            ))}
                        </FilterGroup>

                        <FilterGroup title="Collections">
                            {subCategories?.map((b, index) => 
                            <label key={b.id} className="flex items-center gap-2 mb-1 md:mb-0 text-sm mr-2 md:mr-0">
                                <input onChange={(e) => addSubFilter(e.target.checked, b.id)} type="checkbox" /> {b.name}
                            </label>
                            )}
                        </FilterGroup>

                        <FilterGroup title="Search by Product">
                            <input
                                className="w-full bg-gray-100 rounded px-4 py-2 mt-1"
                                value={searchParam}
                                placeholder="Enter product name..."
                                onChange={(e) => setSearchParam(e.target.value)}
                            />
                        </FilterGroup>
                    </aside>
                    <div className="flex-1">
                        <div className="flex justify-between items-center mb-4">
                            <p className="text-sm text-gray-600">
                            Showing 1 - {products?.length} out of {pagination?.total_product} Products
                            </p>
                            <select selected={sortBy} value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="border px-2 py-1 text-sm">
                                <option value="">Default</option>
                                <option value="New Arrivals">New Arrivals</option>
                                <option value="Best Sellers">Best Sellers</option>
                                <option value="price-low">Price: Low to High</option>
                                <option value="price-low">Price: High to Low</option>
                            </select>
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6">
                            {products.map((i, index) => (
                                <div key={index} className="text-sm">
                                    <div 
                                    onClick={() => {setShowModal(true);setShowDetails({ name: i.name, product_id: i.id }) }} 
                                    style={{ backgroundImage: `url(${i.image})` }}
                                    className="cursor-pointer bg-cover bg-center h-[15em] md:h-60 mb-3" />
                                    <p className="font-medium">{i.name}</p>
                                    <p className="text-gray-500">{i.starts_from}</p>
                                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-2">
                                        <p className={`${i.in_stock > 1 ? 'text-[#00b47a]' : 'text-[#ff0000]'} text-sm italic`}>{i.in_stock} unit(s) left</p>
                                        <div className="flex flex-col">
                                            {/* <button onClick={() => i.in_stock > 0 ? addToCart(i.id, 'product', 1) : null} className="text-md underline">
                                            + Add to Cart
                                            </button> */}
                                            <button className="text-md underline">
                                            {i.category_name}
                                            </button>
                                            
                                            {checkItemInCart(i.id) > 0 &&
                                                <a onClick={() => removeItem(i.id)} className="cursor-pointer text-sm text-gray-500 flex items-center gap-x-1"><LiaTimesSolid color="#585858" size={13} /> {checkItemInCart(i.id)} added</a>
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="mx-auto flex items-center justify-center my-5">
                            <button onClick={() => changePage()} className="border rounded-md border-[#bbbbbb] py-2 px-5 text-[#222222]">Show more products</button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

function FilterGroup({ title, children }) {
  return (
    <Collapsible title={title}>
        <div className="flex flex-wrap md:flex-col md:space-y-2">{children}</div>
    </Collapsible>
  )
}

const Collapsible = ({ title, children, previewCount = 4}) => {
  const [open, setOpen] = useState(true);

//   const childArray = useMemo(() => React.Children.toArray(children), [children]);
//   const visibleChildren = open ? childArray : childArray.slice(0, previewCount);

  return (
    <div className="mb-3 md:mb-6">
        <div onClick={() => setOpen(!open)} className="flex flex-row justify-between items-center mb-2">
            <h4 className="font-semibold">{title}</h4>
            {!open ?
            <IoIosArrowDropdownCircle />
            : 
            <IoIosArrowDropupCircle />
            }
        </div>
        {open && (
            <div>{children}</div>
        )}
        {!open && (
            <div className="w-full" onClick={() => setOpen(!open)}>
                <p className="italics text-underline text-[#585858] text-xs">Show all...</p>
            </div>
        )}
    </div>
  );
};